// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyAnchorPointListListResultModel from '../../model/safety-anchor-point-list-list-result-model';
import SafetyAnchorPointListListResultDTO from '../dto/safety-anchor-point-list-list-result-dto';
import dtoSchema from '../schemas/safety-anchor-point-list-list-result-schema';
import SafetyAnchorPointListModel from '../../model/safety-anchor-point-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SafetyAnchorPointListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyAnchorPointListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SafetyAnchorPointListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SafetyAnchorPointListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SafetyAnchorPointListListResultDTO>): SafetyAnchorPointListListResultModel;
  static toModel(dto: DeepPartial<SafetyAnchorPointListListResultDTO> | undefined | null): SafetyAnchorPointListListResultModel | undefined;
  static toModel(dto: DeepPartial<SafetyAnchorPointListListResultDTO> | undefined | null): SafetyAnchorPointListListResultModel | undefined {
    return dto ? new SafetyAnchorPointListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyAnchorPointListListResultModel> | SafetyAnchorPointListListResultModel): SafetyAnchorPointListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SafetyAnchorPointListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyAnchorPointListListResultModel, can not map to SafetyAnchorPointListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
